/** Strings of the project vision in the project header: `projVisionEn` is the source, `projVisionCs` must have the same keys. */
export const projVisionEn = {
  projVision: {
    open: "Vision",
    title: "Project vision",
    intro:
      "Grand goal, users, quality priorities, what the project is not and how success is measured. Agents read only the approved version.",
    approvedBy: "Approved by {{name}} on {{date}}",
    draftPending: "Vision draft awaits approval",
    draftTitle: "Draft to approve",
    draftHint: "Edit it if you like, then approve. Hub stores it and writes wiki/Vize.md.",
    text: "Vision text",
    approve: "Approve",
    discard: "Discard draft",
    propose: "Draft a vision",
    proposeStarted: "Radim is drafting the vision; it shows here when it's ready.",
    saveFailed: "Couldn't save the vision.",
    approved: "Vision approved.",
    wikiNotWritten:
      "Vision is approved in Hub, but writing it to the repository failed: {{reason}}",
    none: "No vision yet.",
    close: "Close",
  },
};

export const projVisionCs: typeof projVisionEn = {
  projVision: {
    open: "Vize",
    title: "Vize projektu",
    intro:
      "Velký cíl, uživatelé, priority kvality, co projekt není a jak poznáme úspěch. Agenti čtou jen schválenou verzi.",
    approvedBy: "Schválil(a) {{name}} {{date}}",
    draftPending: "Návrh vize čeká na schválení",
    draftTitle: "Návrh ke schválení",
    draftHint: "Můžete ho upravit a pak schválit. Hub ho uloží a zapíše do wiki/Vize.md.",
    text: "Text vize",
    approve: "Schválit",
    discard: "Zahodit návrh",
    propose: "Navrhnout vizi",
    proposeStarted: "Radim vizi navrhuje, až bude hotová, objeví se tady.",
    saveFailed: "Vizi se nepodařilo uložit.",
    approved: "Vize je schválená.",
    wikiNotWritten: "Vize je schválená v Hubu, do repa ji zapsat nešlo: {{reason}}",
    none: "Vize zatím není.",
    close: "Zavřít",
  },
};
